import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { getPosts } from "@/data/blogPosts";
import { useLang } from "@/i18n/LanguageContext";

const TEXTS = {
  de: { kicker: "Für Ihn", title: "Stil-Guides für Männer", sub: "Vom Quiet-Luxury-Thema bis zum Date-Outfit: ehrliche Guides, die Mann wirklich braucht.", cta: "Alle Herren-Guides" },
  en: { kicker: "For Him", title: "Style guides for men", sub: "From quiet luxury to the date outfit: honest guides a man actually needs.", cta: "All men's guides" },
  es: { kicker: "Para Él", title: "Guías de estilo para hombres", sub: "Del quiet luxury al outfit de cita: guías honestas que un hombre necesita de verdad.", cta: "Todas las guías para él" },
  it: { kicker: "Per Lui", title: "Guide di stile per uomo", sub: "Dal quiet luxury all'outfit per l'appuntamento: guide oneste che servono davvero.", cta: "Tutte le guide per lui" },
  fr: { kicker: "Pour Lui", title: "Guides de style pour hommes", sub: "Du quiet luxury à la tenue de rendez-vous : des guides honnêtes dont un homme a vraiment besoin.", cta: "Tous les guides hommes" },
};

export default function MenTeaser() {
  const { t, lang } = useLang();
  const b = t.blog;
  const x = TEXTS[lang] || TEXTS.de;
  const posts = getPosts(lang)
    .filter((p) => p.audience === "men")
    .sort((a, c) => c.date.localeCompare(a.date))
    .slice(0, 3);

  return (
    <section className="py-24 sm:py-32" style={{ background: "var(--on-surface)" }} data-testid="men-teaser-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--gold)", letterSpacing: "0.16em" }}>
              <Star size={11} /> {x.kicker}
            </p>
            <h2 className="mt-5 max-w-xl font-serif-display text-4xl sm:text-5xl font-semibold leading-tight text-white" data-testid="men-teaser-title">
              {x.title}
            </h2>
            <p className="mt-4 max-w-lg text-base" style={{ color: "rgba(252,250,248,0.65)" }}>{x.sub}</p>
          </div>
          <Link
            to="/stil-guide-maenner"
            data-testid="men-teaser-viewall"
            className="gold-underline w-fit text-sm font-medium"
            style={{ color: "var(--gold)" }}
          >
            {x.cta} →
          </Link>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {posts.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.1}>
              <Link
                to={`/blog/${post.slug}`}
                data-testid={`men-teaser-card-${post.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-3xl border transition-shadow duration-500 hover:shadow-[0_24px_48px_-24px_rgba(212,175,55,0.45)]"
                style={{ background: "rgba(252,250,248,0.04)", borderColor: "rgba(252,250,248,0.14)" }}
              >
                <div className="h-44 overflow-hidden">
                  <img src={post.image} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center gap-3 text-[10px] uppercase font-bold" style={{ letterSpacing: "0.1em" }}>
                    <span className="rounded-full border px-3 py-1" style={{ borderColor: "var(--gold)", color: "var(--gold)" }}>{b.catMen}</span>
                    <span style={{ color: "rgba(252,250,248,0.55)" }}>{post.readTime} {b.min}</span>
                  </div>
                  <h3 className="mt-3 flex-1 font-serif-display text-lg font-semibold leading-snug text-white">{post.title}</h3>
                  <span className="mt-4 flex items-center gap-1.5 text-sm font-medium transition-transform duration-300 group-hover:translate-x-1" style={{ color: "var(--gold)" }}>
                    {b.readMore} <ArrowRight size={14} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
